module.exports = __webpack_public_path__ + "static/media/create-feature-food.756049cc.svg";